document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sst-hero]').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-sst-slide]'));
    var prev = hero.querySelector('[data-sst-prev]');
    var next = hero.querySelector('[data-sst-next]');
    if (!slides.length) return;
    var index = 0;
    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, idx) { slide.classList.toggle('is-active', idx === index); });
    }
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    setInterval(function () { show(index + 1); }, 6000);
    show(0);
  });

  document.querySelectorAll('[data-sst-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-sst-main-image]');
    var thumbs = gallery.querySelectorAll('[data-sst-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.getAttribute('data-src');
        main.alt = thumb.getAttribute('data-alt') || '';
      });
    });
  });
});
